import type { PhaseStatus } from '@/mocks/schedule';

const MAP: Record<PhaseStatus, { text: string; cls: string }> = {
  done: { text: '已结束', cls: 'bg-background-200 text-foreground-600' },
  active: { text: '进行中', cls: 'bg-primary-500 text-background-50' },
  upcoming: { text: '未开始', cls: 'bg-secondary-100 text-secondary-800' },
};

export default function PhaseBadge({ status }: { status: PhaseStatus }) {
  const conf = MAP[status];
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium whitespace-nowrap ${conf.cls}`}>
      {conf.text}
    </span>
  );
}